import { ChevronDown } from 'lucide-react';
import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

/**
 * A styled native `<select>`. On a phone the OS picker beats any listbox we
 * could build, and it costs no portal, focus trap or keyboard handling.
 */
export function Select({
  className,
  wrapperClassName,
  ...props
}: ComponentProps<'select'> & { wrapperClassName?: string }) {
  return (
    <div className={cn('relative w-full', wrapperClassName)}>
      <select
        data-slot="select"
        className={cn(
          'border-input min-h-11 w-full appearance-none rounded-lg border bg-white/[0.03] py-2 pr-9 pl-3.5 text-sm transition-[border-color,box-shadow] outline-none',
          'focus-visible:border-ring focus-visible:ring-ring/25 focus-visible:ring-[3px]',
          'disabled:cursor-not-allowed disabled:opacity-50',
          '[&>option]:bg-elevated [&>option]:text-foreground',
          className,
        )}
        {...props}
      />
      <ChevronDown
        aria-hidden
        className="text-muted-foreground pointer-events-none absolute top-1/2 right-3 size-4 -translate-y-1/2"
      />
    </div>
  );
}
